import React, { useRef, useState, useEffect } from 'react';
import { IS_PRERENDER } from '../lib/prerender';

export function SectionFallback({ minHeight = 'min-h-[50vh]' }) {
    return (
        <div className={`${minHeight} w-full flex items-center justify-center`} aria-hidden="true">
            <div className="w-8 h-8 rounded-full border-2 border-indigo-500/30 border-t-indigo-500 animate-spin" />
        </div>
    );
}

export default function LazySection({ children, className = '', minHeight = 'min-h-[50vh]' }) {
    const ref = useRef(null);
    const [active, setActive] = useState(IS_PRERENDER);

    useEffect(() => {
        if (IS_PRERENDER || typeof IntersectionObserver === 'undefined') {
            setActive(true);
            return;
        }

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActive(true);
                        io.disconnect();
                    }
                });
            },
            { rootMargin: '600px 0px' }
        );

        const node = ref.current;
        if (node) io.observe(node);

        return () => io.disconnect();
    }, []);

    const placeholder = <SectionFallback minHeight={minHeight} />;

    return (
        <div ref={ref} className={`w-full ${className}`}>
            {active ? (
                <React.Suspense fallback={placeholder}>{children}</React.Suspense>
            ) : (
                placeholder
            )}
        </div>
    );
}